/**
 * Context for communicating step-level layout preferences (e.g. wide layout)
 * from deep inside the funnel engine up to the App shell.
 */
import { createContext, useContext } from "react";

type FunnelLayoutContextValue = {
  wideLayout: boolean;
  setWideLayout: (wide: boolean) => void;
};

export const FunnelLayoutContext = createContext<FunnelLayoutContextValue>({
  wideLayout: false,
  setWideLayout: () => {},
});

export const useFunnelLayout = (): FunnelLayoutContextValue => useContext(FunnelLayoutContext);
